import { combineReducers } from 'redux';

import adherences from './adherences-reducer';
import pagination from './reducer-pagination';
import searchTerm from './reducer-search';
import orderBy from './reducer-orderBy';
import downloadAdh from './reducer-downloadAdherences';
import searchBy from './reducer-searchBy';
import dateRange from './reducer-dates';
import searchByProtocol from './reducer-searchByProtocol';
import searchDate from './reducer-searchByDates';

export default combineReducers( {
	                                adherences,
	                                pagination,
	                                searchTerm,
	                                orderBy,
	                                downloadAdh,
	                                searchBy,
	                                dateRange,
	                                searchByProtocol,
	                                searchDate
                                } );